export const WORKPLACE = "workplace"
